import { difference, uniq } from 'lodash';
import type { TObjectImportJob, TObjectJob } from 'types/objectJob.type';

export const calculateSummaryOfJob = (job: TObjectJob) => {
  if (job.operationType === 'IMPORT') return calculateSummaryOfImportJob(job);

  const isFinished = ['FINISHED', 'FAILED'].includes(job.status);
  const notInSuccess = isFinished
    ? difference(
        job.objectsToProcess.map((o) => o.id),
        job.successfulObjects
      )
    : [];

  const failed = uniq(
    notInSuccess.concat(job.batchErrors.flatMap((e) => e.objects))
  );

  return {
    total: job.objectsToProcess.length,
    successful: job.successfulObjects.length,
    failed: failed.length,
  };
};

export const invalidateTagsByResponseId = (
  response: { id: string } | undefined
) => {
  if (!response) return [] as const;
  return [
    { type: 'ObjectJob', id: 'LIST' },
    { type: 'ObjectJob', id: 'STATUS' },
    { type: 'ObjectJob', id: response.id },
  ] as const;
};

const calculateSummaryOfImportJob = (job: TObjectImportJob) => {
  const isFinished = ['FINISHED', 'FAILED'].includes(job.status);
  const notInSuccess = isFinished
    ? difference(
        job.objectsToProcess,
        job.successfulObjects.map((o) => o.extId)
      )
    : [];

  const failed = uniq(
    notInSuccess.concat(
      job.batchErrors.flatMap((e) =>
        e.objects
          .map((e) => (typeof e === 'string' ? e : e.extId))
          .filter((e) => e != null)
      )
    )
  );

  return {
    total: job.objectsToProcess.length,
    successful: job.successfulObjects.length,
    failed: failed.length,
  };
};
